/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

(function ($) {
    $(document).ready(function () {

        console.log('Hero Poster Block JS Loaded');

        // create slideshow of divs with the slideshow__slide class
        let slideIndex = 0,
            $slides = $(".slideshow__slide"),
            numSlides = $(".slideshow__slide").length,
            duration = $('#slideshow').data('duration'),
            fadeInDuration = 1000;

        showSlides();

        function showSlides() {

            let $nextSlide = $slides.eq(slideIndex % numSlides);
            $nextSlide.removeClass("slideshow__slide--active").css('z-index', slideIndex++);
            $nextSlide.addClass("slideshow__slide--active");

            setTimeout(showSlides, duration - fadeInDuration);

            // remove the active class from the previous slide after fadeInDuration
            setTimeout(function () {
                $nextSlide.siblings().removeClass("slideshow__slide--active");
            }, fadeInDuration);

        }


    });
})(jQuery);
